module.exports = __webpack_public_path__ + "img/stackslash-process-6.77f858ee.jpg";